import React, { MouseEvent, useCallback } from 'react';
import { Box, ClickAwayListener } from '@mui/material';
import SwipeableDrawer from '@core/dashboard/components/SwipeableDrawer';
import HomeBarButton from '../HomeBarButton';

import { useToggle } from './hooks';
import { IIconPopoverView } from './interfaces';
import { useMytaverseEvent } from '@core/dashboard/providers';
import { AnalyticsType } from '@interfaces/analytics';

const IconPopover = ({
  children,
  icon,
  label,
  onClick = null,
  buttonSx = {},
  popoverSx = {},
  position = {
    vertical: 'bottom',
    horizontal: 'right',
  },
  disableClickAway = false,
  analyticsName,
}: IIconPopoverView) => {
  const { trackEventAnalytics } = useMytaverseEvent();
  const { isOpen, handleClick, handleClose } = useToggle();

  const handleToggleDrawer = useCallback(
    (e: MouseEvent<HTMLButtonElement>) => {
      handleClick(e);
      onClick?.(!isOpen);
      if (!isOpen && analyticsName) {
        trackEventAnalytics(AnalyticsType.NavbarButtonClick, {
          name: analyticsName,
        });
      }
    },
    [isOpen, trackEventAnalytics],
  );

  const handleCloseDrawer = useCallback(() => {
    handleClose();
    onClick?.(false);
  }, [handleClose, onClick]);

  const handleClickAway = () => {
    if (!disableClickAway) {
      handleCloseDrawer();
    }
  };

  return (
    <ClickAwayListener onClickAway={handleClickAway}>
      <Box>
        <HomeBarButton
          label={label}
          icon={icon}
          isActive={isOpen}
          handleClick={handleToggleDrawer}
          buttonSx={buttonSx}
        />

        <SwipeableDrawer
          position={position}
          open={isOpen}
          onClose={handleCloseDrawer}
          onOpen={handleToggleDrawer}
          sx={popoverSx}
        >
          {children({ onClose: handleCloseDrawer, isOpen })}
        </SwipeableDrawer>
      </Box>
    </ClickAwayListener>
  );
};

export default IconPopover;
